/**
 * Central registry of feature gate keys used in the application.
 * Add new feature gate keys here as string constants.
 */
export const featureGateKeys = {
  /**
   * PAU_AI_IMPACT_AND_CONTEXT_TAGS
   * @link https://hello.atlassian.net/browse/FD-202623
   * @description Controls visibility of AI-generated Impact rating and
   * Contextual tags columns on the list and details pages.
   * OFF by default — safe to merge at any time.
   * @returns true if the AI Impact and Contextual tags columns should be shown
   */
  aiImpactAndContextTags: 'public_app_updates_ai_impact_and_context_tags',
  /**
   * FETCH_AVAILABLE_APPS
   * @link https://switcheroo.atlassian.com/ui/gates/ba2d0e9b-e87d-414f-89d0-dab975f950bb/key/fetch_available_apps
   * @description Controls whether the product filter dropdown fetches available
   * apps from the API instead of using the hardcoded list.
   * OFF by default — falls back to getVisibleApps().
   * @returns true if the product filter should fetch apps from the API
   */
  fetchAvailableApps: 'fetch_available_apps',
  /**
   * @deprecated A fake gate key used only in unit tests to exercise the fg() utility.
   * Not a real Switcheroo gate — do not use in production code.
   */
  testOnly: 'test-gate-for-unit-tests',
} as const;

export type FeatureGateValue =
  (typeof featureGateKeys)[keyof typeof featureGateKeys];
